import { CheckOutlined, CloseOutlined } from "@ant-design/icons"
import {Modal, Form, Input, Radio, Space, Button, Select} from "antd"
import axios from "axios"
import { useEffect, useRef } from "react"

const backend = process.env.REACT_APP_BACKEND;

export default function InsertWordModal ({insertModal, modalHandler, pos, getSourceData}) {
  const ref = useRef()

  //초기화 버튼 함수
  const clearHandler = () => {
    ref.current.resetFields()
  }
  //단어 등록 함수
  const insertHandler = async () => {
    try {
      await ref.current.validateFields()
      const values = await ref.current.getFieldsValue()
  
      axios.post(`${backend}/contents/new_word/word/list`,{values})
        .then(res => {
          getSourceData()
          Modal.success({
            title: "등록 완료",
            content: "정상적으로 등록 되었습니다.",
            okText: "확인",
            afterClose: ()=>modalHandler("insertModal", false)
          })
        })
        .catch(err => {
          console.log(err)
          if(err.response?.status === 409) {
            Modal.error({
              title: "중복에러",
              content: err.response.data.message,
              okText:"확인",
              cancelText:"취소"
            })
          }
        })
    } catch (err) {
      console.log(err)
    }
  }

  //단어 등록 후 계속 함수
  const insertContinueHandler = async () => {
    try {
      await ref.current.validateFields()
      const values = await ref.current.getFieldsValue()
  
      axios.post(`${backend}/contents/new_word/word/list`,{values})
        .then(res => {
          getSourceData()
          Modal.success({
            title: "등록 완료",
            content: "정상적으로 등록 되었습니다.",
            okText: "확인",
            afterClose: ()=>{
              ref.current.resetFields()
            }
          })
        })
        .catch(err => {
          console.log(err)
          if(err.response?.status === 409) {
            Modal.error({
              title: "중복에러",
              content: err.response.data.message,
              okText:"확인",
              cancelText:"취소"
            })
          }
        })
    } catch (err) {
      console.log(err)
    }
  }

  //취소 버튼 함수
  const cancelHandler = () => {
    modalHandler("insertModal", false)
  }

    // // 형식명칭 validator 함수
    // const nameValidator = (_, value) => {
    //   const code = formRef.current.getFieldValue("code");
    //   for (let i = 0; i < sourceDataKor.length; i++) {
    //     if (
    //       code !== sourceDataKor[i].code &&
    //       value &&
    //       value === sourceDataKor[i].name
    //     ) {
    //       return Promise.reject(
    //         new Error(`동일한 성분명칭(한국어) "${value}"가 이미 존재합니다.`)
    //       );
    //     }
    //   }
    //   return Promise.resolve();
    // };

  return (
    <Modal 
      open={insertModal}
      destroyOnClose = {true}
      title = "단어 등록"
      okText = "확인"
      cancelText = "취소"
      onCancel={()=>modalHandler("insertModal", false)}
      maskClosable = {false}
      footer = {
        <Space style={{width:"100%", justifyContent:"space-between"}}>
          <Button onClick={clearHandler}>내용 초기화</Button>
          <Space>
            <Button type="primary" onClick={insertHandler}><CheckOutlined/>등록</Button>
            <Button onClick={insertContinueHandler}><CheckOutlined/>등록 후 계속</Button>
            <Button onClick={cancelHandler}><CloseOutlined/>취소</Button>
          </Space>
        </Space>
      }
    >
      <Form layout="vertical" ref={ref}>

        <Form.Item
          name="word"
          label="단어"
          rules={[
            {required: true, message:"필수 입력값입니다."}
          ]}
        >
          <Input></Input>
        </Form.Item>

        <Form.Item
          name="ContentSettingPartsOfSpeechMaster_code"
          label="품사"
          rules={[
            {required: true, message:"필수 입력값입니다."}
          ]}
        >
          <Select options = {pos} />
        </Form.Item>

        <Form.Item 
          name="cefr_evp"
          label="CEFR Level (EVP)"
          rules={[
            {required: true, message:"필수 입력값입니다."}
          ]}
        >
          <Radio.Group>
            <Radio value={"A0"}>A0</Radio>
            <Radio value={"A1"}>A1</Radio>
            <Radio value={"A2"}>A2</Radio>
            <Radio value={"B1"}>B1</Radio>
            <Radio value={"B2"}>B2</Radio>
            <Radio value={"C1"}>C1</Radio>
            <Radio value={"C2"}>C2</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item 
          name="derivative"
          label="파생어 (여러 개일 경우 콤바 ‘,’ 로 구분하여 입력)"

        >
          <Input></Input>
        </Form.Item>
        
      </Form>
    </Modal>
  )
}